import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { createUploadLink } from 'apollo-upload-client';

import { URI } from '../constants/api';
import { getToken } from '../helpers/storage';

const authLink = setContext(async (_, { headers }) => {
  let token = await getToken();
  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}` || '',
    },
  };
});

const httpLink = createUploadLink({
  uri: URI,
  credentials: 'same-origin',
});

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
});
